import {
  AppForSa,
  DeProvisionStatus,
  ServiceForReAuth,
} from '@Types/administrator';
import { TokenStatus } from '@Types/provision';

// export const SERVICE_TYPE = new Map<number | 'rms', string>([
//   [0, ""],
//   [1, "exchange"],
//   [2, "azure_online"],
//   [3, "gloabl_admin"],
//   [4, "sharepoint"],
//   [5, "box"],
//   [6, "dropbox"],
//   [7, "googledrive"],
//   [10, "salesforce_sandbox"],
//   [11, "salesforce_production"],
//   [15, "sharepoint"],
//   [16, "onedrive"],
//   [21, "gmail"],
//   [22, "gmail_inline"],
//   [35, "microsoft_identity_protection"],
//   [41, "teams"],
//   [42, "teams_chat"],
//   [46, "microsoft_information_protection"],
//   [51, "exchangeserver"],
//   [81, "exchange_mail_flow"],
//   [82, "exchange_inline"],
//   ['rms', 'rms']
// ]);

export interface AccountData {
  orgId: string;
  orgName: string;
  apps: AppData[];
  deprovisioning?: boolean;
  tokens?: Record<string, string>;
}

export interface AppData {
  email: string;
  app: AppForSa;
  endDate: string;
  valid: boolean;
  status: number;
  extra: number;
  provisionFromGraphapi: number | null;
  token?: string;
  reAuthDisabled?: boolean;
  migrationStatus: number;
  deprovisioningStatus?:
    | DeProvisionStatus.DeProvisioning
    | DeProvisionStatus.Failure;
  isPoc: boolean;
  provisionType: number;
}

export interface SelectedRow {
  orgId: string;
  app: AppForSa;
}

export enum SaModalNameEnum {
  ReAuth = 'reAuth',
  Extend = 'extend', //for exchange server
  SpodMigration = 'spodMigration',
  Deprovision = 'deprovision',
  Provision = 'provision',
  Details = 'details', //for deprovisioning or deprovision failed
  UpdateSecretOrChangeApp = 'updateSecretOrChangeApp', //for teams chat
  ProtectOwnApp = 'protectOwnApp', //for teams chat
  ChangePassword = 'changePassword', //for deprecatedSpod
  NeedLicense = 'needLicense',
  CleanUp = 'cleanup',
  PocExtend = 'pocExtend',
}

export enum MigrationService {
  SharePoint = 'sharePoint',
  OneDrive = 'oneDrive',
}

export type SaModalState =
  | {
      name: SaModalNameEnum.Deprovision | SaModalNameEnum.Provision;
      data: {
        orgId: string;
        app: AppForSa;
      };
    }
  | {
      name: SaModalNameEnum.ReAuth;
      data: {
        orgId: string;
        service: ServiceForReAuth;
        authAccount: string;
        provisionType: number;
      };
    }
  | {
      name: SaModalNameEnum.Extend | SaModalNameEnum.ProtectOwnApp;
      data: {
        orgId: string;
      };
    }
  | {
      name: SaModalNameEnum.UpdateSecretOrChangeApp;
      data: {
        orgId: string;
        appId: string;
      };
    }
  | {
      name: SaModalNameEnum.Details;
      data: {
        orgId: string;
        app: AppForSa;
        status: DeProvisionStatus.Failure | DeProvisionStatus.DeProvisioning;
      };
    }
  | {
      name: SaModalNameEnum.SpodMigration;
      data: {
        orgId: string;
        // service: MigrationService;
      };
    }
  | {
      name: SaModalNameEnum.NeedLicense;
      data: {
        app: AppForSa.ExchangeInline | AppForSa.GmailInline;
      };
    }
  | {
      name: SaModalNameEnum.ChangePassword;
      data: {
        email: string;
        orgId: string;
      };
    }
  | {
      name: SaModalNameEnum.CleanUp;
      data: {
        orgId: string;
      };
    }
  | {
      name: SaModalNameEnum.PocExtend;
      data: {
        orgId: string;
      };
    }
  | null;

export interface Token {
  tokenStatus: TokenStatus;
  appId: string;
  appOwner: number;
  tokenTypes: number[];
}

export enum MigrationStatus {
  // init status
  NotStarted = 'notStarted',
  // creating token
  CreateToken = 'createToken',
  // any token failure or sync target failure
  Failure = 'failure',
  // syncing target
  Migrating = 'migrating',
  // syncing target success and need to clean up
  Cleanup = 'cleanup',
  Migrated = 'migrated',
}
